export const RoleManager = 'manager';
export const RoleMember = 'member';
export const RoleAdmin = 'admin';
